export default "__VITE_ASSET__9M7aaeTl__"